import React, { useEffect, useRef, useState } from 'react';



const CARTO_API_KEY = 'cb1_4rm3_2_e4b4aae36591237adfcfe1eb';

const TILE_URL =
  `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${CARTO_API_KEY}`;

const SIZE = 256;



const project = (lat, lon, z) => {
  const n = 2 ** z;
  const rad = (lat * Math.PI) / 180;
  return {
    x: ((lon + 180) / 360) * n,
    y: ((1 - Math.log(Math.tan(rad) + 1 / Math.cos(rad)) / Math.PI) / 2) * n,
  };
};

/* Fills its positioned parent. precise = exact address (street zoom, pin);
   otherwise a county-level view with a soft area ring. */
export default function MapView({ lat, lon, precise = true }) {
  const ref = useRef(null);
  const [box, setBox] = useState({ w: 640, h: 320 });

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(([e]) => setBox({ w: e.contentRect.width, h: e.contentRect.height }));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const z = precise ? 16 : 11;
  const n = 2 ** z;
  const c = project(lat, lon, z);
  const retina = typeof window !== 'undefined' && window.devicePixelRatio > 1 ? '@2x' : '';
  const cols = Math.ceil(box.w / SIZE / 2) + 1;
  const rows = Math.ceil(box.h / SIZE / 2) + 1;

  const tiles = [];
  for (let dx = -cols; dx <= cols; dx += 1) {
    for (let dy = -rows; dy <= rows; dy += 1) {
      const tx = Math.floor(c.x) + dx;
      const ty = Math.floor(c.y) + dy;
      if (ty < 0 || ty >= n) continue;
      const wx = ((tx % n) + n) % n;
      tiles.push({
        key: `${tx}/${ty}`,
        left: box.w / 2 + (tx - c.x) * SIZE,
        top: box.h / 2 + (ty - c.y) * SIZE,
        src: TILE_URL.replace('{s}', 'abcd'[(wx + ty) % 4]).replace('{z}', z)
          .replace('{x}', wx).replace('{y}', ty).replace('{r}', retina),
      });
    }
  }

  return (
    <div ref={ref} aria-hidden="true" style={{ position: 'absolute', inset: 0, overflow: 'hidden', background: '#e9eef1' }}>
      {tiles.map((t) => (
        <img key={t.key} src={t.src} alt="" draggable={false} width={SIZE} height={SIZE}
          style={{ position: 'absolute', left: t.left, top: t.top, width: SIZE, height: SIZE, maxWidth: 'none', userSelect: 'none' }} />
      ))}

      {precise ? (
        <svg width="36" height="46" viewBox="0 0 36 46"
          style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-100%)', filter: 'drop-shadow(0 3px 4px rgba(0,0,0,.35))' }}>
          <path d="M18 1C8.600 1 1 8.600 1 18c0 12.500 17 27 17 27s17-14.500 17-27C35 8.600 27.400 1 18 1z" fill="#fff000" stroke="#000" strokeWidth="2.500" />
          <circle cx="18" cy="18" r="6" fill="#000" />
        </svg>
      ) : (
        <div style={{ position: 'absolute', left: '50%', top: '50%', width: 150, height: 150, margin: '-75px 0 0 -75px', borderRadius: '50%', border: '2px dashed #000', background: 'rgba(255,240,0,.3)' }} />
      )}

      <span style={{ position: 'absolute', right: 0, bottom: 0, padding: '2px 8px', borderTopLeftRadius: 6, background: 'rgba(255,255,255,.85)', font: '10px Inter, sans-serif', color: '#444' }}>
        © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer" style={{ color: 'inherit' }}>OpenStreetMap</a>{' '}
        © <a href="https://carto.com/attributions" target="_blank" rel="noreferrer" style={{ color: 'inherit' }}>CARTO</a>
      </span>
    </div>
  );
}
